import React from 'react';
import { AssignedTerritory, EmployeeInfo } from '../profileTypes';
import styles from './AssignmentCards.module.css';

interface AssignmentCardsProps {
  territory: AssignedTerritory;
  employee: EmployeeInfo;
}

export const AssignmentCards: React.FC<AssignmentCardsProps> = ({ territory, employee }) => {
  return (
    <div className={styles.row}>
      <div className={styles.card}>
        <span className={styles.iconBox}>📍</span>
        <div>
          <p className={styles.label}>Assigned Territory</p>
          <p className={styles.value}>{territory.name}</p>
        </div>
      </div>
      <div className={styles.card}>
        <span className={styles.iconBox}>💼</span>
        <div>
          <p className={styles.label}>Employee Information</p>
          <p className={styles.value}>ID: {employee.staffId}</p>
          <p className={styles.subValue}>Since {employee.startedSince}</p>
        </div>
      </div>
    </div>
  );
};
